export const FormLabel = {
  baseStyle: {
    fontSize: 'md',
  },
};
